import currencyFormatter from 'currency-formatter'
import { useNavigate } from 'react-router-dom'
import { CheckCircleIcon } from '@heroicons/react/solid'
import Card from 'components/Card'
import TopUpLayout from 'components/Layouts/TopUpLayout'
import useAuth from 'hooks/useAuth'
import { useEffect } from 'react'

const SuccessCashIn = () => {
  const navigate = useNavigate()
  const auth = useAuth()

  useEffect(() => {
    return () => {
      auth.setTopUpAmount('0')
    }
  }, [auth])

  return (
    <TopUpLayout>
      <Card>
        <div className="p-8 text-center">
          <div className="w-20 h-20 rounded-full bg-success-100 flex items-center justify-center mx-auto mb-6">
            <CheckCircleIcon className="w-10 h-10 text-success-600" />
          </div>

          <h2 className="text-2xl font-bold text-neutral-800 mb-2">
            Top Up Successful!
          </h2>

          <p className="text-neutral-500 mb-6">
            You have successfully added funds to your wallet
          </p>

          <div className="bg-neutral-50 rounded-xl p-4 mb-8 inline-block">
            <span className="text-sm text-neutral-500 block mb-1">Amount added</span>
            <span className="text-3xl font-bold text-success-600">
              {currencyFormatter.format(auth.topUpAmount(), {
                symbol: 'SGD',
                format: '%s %v',
              })}
            </span>
          </div>

          <button
            className="btn-primary btn-lg w-full"
            onClick={() => navigate('/dashboard')}
          >
            Back to Dashboard
          </button>
        </div>
      </Card>
    </TopUpLayout>
  )
}

export default SuccessCashIn
